import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import {
  AppBar,
  CssBaseline,
  Divider,
  Drawer,
  Hidden,
  Button,
  Box,
  List,
  ListItem,
  ListItemIcon,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import HistoryIcon from "@material-ui/icons/History";
import ExitToApp from "@material-ui/icons/ExitToApp";
import CancelIcon from "@material-ui/icons/Cancel";
import ReplayIcon from "@material-ui/icons/Replay";
import ListIcon from "@material-ui/icons/ListAlt";

import logo from "./logo-header.svg";

import { Roles } from "./config";
import { ordersPageTitle } from "./utils";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    color: "#fff",
  },
  logo: {
    maxWidth: 64,
    maxHeight: 64,
    marginLeft: 20,
    marginRight: 20,
  },
  title: {
    flexGrow: 1,
  },
  logout: {
    marginLeft: theme.spacing(2),
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: 0,
  },
  exitButton: {
    marginLeft: "10px",
  },
}));

function logout() {
  localStorage.removeItem("authToken");
  localStorage.removeItem("userId");
  window.location.replace("/login");
}

function MainLayout(props) {
  const { container, children, pageTitle } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <div
        className={classes.toolbar}
        style={{ backgroundColor: "#5D3EBD", paddingTop: "15px" }}
      >
        <img src={logo} alt="Logo" className={classes.logo} />
      </div>
      <Divider />
      <List>
        <ListItem
          button
          component={Link}
          to="/orders"
          selected={window.location.pathname === "/orders"}
        >
          <ListItemIcon>
            <HistoryIcon />
          </ListItemIcon>
          {ordersPageTitle(localStorage.getItem("role"))}
        </ListItem>
        {Roles.GETIR_MH === localStorage.getItem("role") && (
          <>
            <ListItem
              button
              component={Link}
              to="/cancelled-orders"
              selected={window.location.pathname === "/cancelled-orders"}
            >
              <ListItemIcon>
                <CancelIcon />
              </ListItemIcon>
              İptal Siparişler
            </ListItem>
          </>
        )}
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={classes.appBar}
        component={Box}
        displayPrint="none"
      >
        <Toolbar>
          <Typography variant="h6" noWrap className={classes.title}>
            {pageTitle}
          </Typography>
          <Button color="inherit" className={classes.logout} onClick={logout}>
            <ExitToApp />{" "}
            <Typography className={classes.exitButton} variant="button">
              Çıkış Yap
            </Typography>
          </Button>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer}>
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {children}
      </main>
    </div>
  );
}

MainLayout.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  container: PropTypes.any,
};

export default MainLayout;
